import * as React from "react";

function GiftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: props.color || 'current',
    viewBox: "0 0 32 32",
    "aria-hidden": "true",
    width: props.width || '32px'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'current',
    fillRule: "evenodd",
    d: "M10.6 4a2 2 0 000 4h4.071a10.32 10.32 0 00-.673-1.518C13.232 5.088 12.144 4 10.6 4zm-4 2a4 4 0 00.536 2H2v9h2v13h24V17h2V8h-5.136A4 4 0 0021.4 2c-2.656 0-4.268 1.912-5.151 3.518-.089.161-.172.322-.25.48-.077-.158-.16-.319-.248-.48C14.867 3.912 13.256 2 10.6 2a4 4 0 00-4 4zm10.729 2H21.4a2 2 0 000-4c-1.544 0-2.632 1.088-3.399 2.482A10.31 10.31 0 0017.33 8zm4.071 2H17v5h11v-5h-6.6zM15 10H4v5h11v-5zm11 18V17h-9v11h9zm-11 0H6V17h9v11z",
    clipRule: "evenodd"
  }));
}

export default GiftIcon;